// extracted by mini-css-extract-plugin
module.exports = {"title":"WebinarsEdidPage_title__giAsF","buttonFooter":"WebinarsEdidPage_buttonFooter__2BTr7","link":"WebinarsEdidPage_link__WV3RE","mr_10":"WebinarsEdidPage_mr_10__KPNjE"};